import { FileText, Download, Sparkles } from "lucide-react";
import { API, track } from "@/lib/api";

export function PdfButton({ tutorial, compact = false }) {
  const manual = tutorial.pdf_url;
  const url = manual || `${API}/tutorials/${tutorial.slug}/pdf`;
  const auto = !manual;
  const withDl = (u) => (u.includes("/api/") ? `${u}${u.includes("?") ? "&" : "?"}download=1` : u);
  const open = () => {
    track("pdf_open", tutorial.slug);
    const a = document.createElement("a");
    a.href = url; a.target = "_blank"; a.rel = "noopener noreferrer";
    document.body.appendChild(a); a.click(); a.remove();
  };
  const download = () => { track("pdf_download", tutorial.slug); window.location.href = withDl(url); };
  const ic = compact ? "w-3.5 h-3.5" : "w-4 h-4";

  return (
    <div className={`inline-flex ${compact ? "" : "w-full sm:w-auto"} rounded-full overflow-hidden shadow-lg shadow-amber-500/10`}
      data-testid="tutorial-pdf-group" data-source={auto ? "auto" : "manual"}>
      <button onClick={open} data-testid="tutorial-pdf-open" title={auto ? "PDF gerado automaticamente a partir dos passos" : "Abrir PDF em nova aba"}
        className={`ci-btn-gold inline-flex items-center justify-center gap-2 font-semibold hover:brightness-105 transition flex-1 ${compact ? "text-xs px-3 py-1.5" : "text-sm px-5 py-3"}`}>
        <FileText className={ic} /> Baixar Tutorial em PDF
        {auto && !compact && <Sparkles className="w-3.5 h-3.5 opacity-70" data-testid="tutorial-pdf-auto-badge" />}
      </button>
      <button onClick={download} data-testid="tutorial-pdf-download" title="Salvar arquivo" aria-label="Salvar PDF"
        className={`inline-flex items-center justify-center bg-amber-300 text-[#0B0F17] border-l border-[#0B0F17]/20 hover:bg-amber-200 transition ${compact ? "px-2.5" : "px-4"}`}>
        <Download className={ic} />
      </button>
    </div>
  );
}
